import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/react-hooks';
import { kmsClient } from '../../apollo';
import { ArticleLeadFormsQuery, ArticleLeadFormsQueryVariables } from './__generated__/ArticleLeadFormsQuery';

export const ARTICLE_LEAD_FORMS_QUERY = gql`
  query ArticleLeadFormsQuery($id: ID!) {
    article(id: $id) {
      campaign {
        campaignObjective
      }
      facebookLeadgenForms {
        id
        name
        externalId
        leadsCount
        leadsCountUpdatedAt
        createdAt
        discardedAt
        spec
        encodedFacebookLeadgenFormSetId
      }
    }
  }
`;

export const useArticleLeadFormsLazyQuery = () => {
  return useLazyQuery<ArticleLeadFormsQuery, ArticleLeadFormsQueryVariables>(ARTICLE_LEAD_FORMS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true
  });
};
